angular.module('TetherApp').factory('shortcodeService', [
    '$http',
    function ($http) {

        let randomString = function (length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let indexShortcode = function () {
            let uri = '/api/v1/shortcode/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            indexShortcode: indexShortcode
        }

    }
]);
